import { get } from 'lodash';

export const formatRecapExpertise = (missions: any) => {
  return missions
    ?.map((el: any) => ({
      missionExpertiseVictim: el.missionExpertiseVictim?.map((item: any) => ({
        ...item,
        type: el.type,
        mission: {
          ...el,
        },
        victim: {
          ...get(el, 'victims[0]'),
        },
      })),
    }))
    .flatMap((test: any) => test.missionExpertiseVictim);
};
